<template>
    <v-dialog v-model="dialogOpen" persistent max-width="480">
        <v-card>
            <v-card-title class="headline">
                Accès protégé
            </v-card-title>
            <v-card-text class="lock-screen">
                <v-form v-if="nb_try < 3" ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                        <v-layout row wrap align-center>
                            <v-flex offset-xs4 xs1>
                                <v-card dark color="secondary">
                                    <v-card-text class="px-0">
                                        <input @keyup="updateInput($event, 'input2')" maxlength="1"
                                               v-model="input1" ref="input1" @focusin="input1 = ''"
                                               type="text" pattern="[0-9]*" inputmode="numeric"
                                               min="0" max="9"
                                               required autofocus>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs1>
                                <v-card dark color="secondary">
                                    <v-card-text class="px-0">
                                        <input @keyup="updateInput($event, 'input3')" maxlength="1"
                                               v-model="input2" ref="input2"
                                               type="text" pattern="[0-9]*" inputmode="numeric"
                                               min="0" max="9"
                                               @focusin="input2 = ''; input1 === '' ? moveInputToPrevious('input1') : null"
                                        >
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs1>
                                <v-card dark color="secondary">
                                    <v-card-text class="px-0">
                                        <input @keyup="updateInput($event, 'input4')" maxlength="1"
                                               v-model="input3" ref="input3"
                                               type="text" pattern="[0-9]*" inputmode="numeric"
                                               min="0" max="9"
                                               @focusin="input3 = ''; input2 === '' ? moveInputToPrevious('input2') : null"
                                        >
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs1>
                                <v-card dark color="secondary">
                                    <v-card-text class="px-0">
                                        <input @keyup="updateInput" maxlength="1" v-model="input4" ref="input4"
                                               type="text" pattern="[0-9]*" inputmode="numeric"
                                               min="0" max="9"
                                               @focusin="input4 = ''; input3 === '' ? moveInputToPrevious('input3') : null"
                                        >
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="closeDialog">Annuler</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "ProtectedDialog",
    props: {
        modalToOpen: Function,
        confirmDialog: Boolean
    },

    data() {
        return {
            input1: '',
            input2: '',
            input3: '',
            input4: '',
            nb_try: 0,
            dialogOpen: false
        }
    },
    watch: {
        confirmDialog: function (val) {
            this.dialogOpen = val
            this.$refs['input1'].focus()
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions(["validateUnlock"]),
        closeDialog() {
            this.dialogOpen = false;
            this.$emit('dialog-closed');
        },
        updateInput(event, next) {
            if (next) {
                this.$refs[next].focus()
            } else {
                this.validateUnlock({code: "" + this.input1 + this.input2 + this.input3 + this.input4}).then(response => {
                    this.dialogOpen = false;
                    this.nb_try = 0;

                    this.modalToOpen()
                    this.input1 = ''
                    this.input2 = ''
                    this.input3 = ''
                    this.input4 = ''

                }).catch(reason => {
                    this.input1 = ''
                    this.input2 = ''
                    this.input3 = ''
                    this.input4 = ''

                    this.$refs.input1.focus()
                    this.nb_try++

                    if (this.nb_try > 2) {
                        this.dialogOpen = false;
                        this.nb_try = 0;
                    }
                })
            }
        },
        moveInputToPrevious(ref) {
            this.$refs[ref].focus()
        },
    },
}
</script>
